'use client';

import { useRef, useEffect, cloneElement, isValidElement } from 'react';
import { FocusTrapProps } from './FocusTrap.types';

export const FocusTrap = ({ children }: FocusTrapProps) => {
  const childRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const child = childRef.current;

    const focusableElements = child?.querySelectorAll<HTMLElement>(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );

    const firstElement = focusableElements?.[0];
    firstElement?.focus();
    const lastElement = focusableElements?.[focusableElements.length - 1];

    const handleTabKeyPress = (event: KeyboardEvent) => {
      if (event.key !== 'Tab') return;

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement?.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement?.focus();
      }
    };

    child?.addEventListener('keydown', handleTabKeyPress);
    return () => child?.removeEventListener('keydown', handleTabKeyPress);
  }, []);

  if (isValidElement(children)) {
    return cloneElement(children, {
      // @ts-expect-error: TypeScript doesn’t infer ref correctly here
      ref: childRef,
    });
  }

  return null;
};
